import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-financeimpact-dashboard',
  templateUrl: './financeimpact-dashboard.component.html',
  styleUrls: ['./financeimpact-dashboard.component.scss']
})
export class FinanceimpactDashboardComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
